// extracted by mini-css-extract-plugin
export default {"waikawaGray":"#666","black":"#000","manageUser":"styles_manageUser__JSpTb","manageUserMenu":"styles_manageUserMenu__0bcHY"};